/* eslint-disable react/no-unescaped-entities */
import styled from 'styled-components';

const ConfigError = () => (
  <Wrapper>
    <h4 style={{ color: '#d87675' }}>Widget Token Missing</h4>
    <p style={{ color: '#a3a3a3', marginTop: '20px' }}>
      An error occurred while loading the chat widget. We are expecting you to provide "token" generated using your
      client keys.
    </p>
  </Wrapper>
);

export default ConfigError;

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
